<template>
  <div>

    <div class="text-center p-5">
      {{ $t('event.timeline.zoomMeeting.title') }}:<br>
      <VueCountdown
        ref="countdown"
        :time="time"
        :autoStart="started"
      >
        <template slot-scope="props">{{ props.days }} {{ $t('event.timeline.zoomMeeting.days') }}, {{ props.hours }} {{ $t('event.timeline.zoomMeeting.hours') }}, {{ props.minutes }} {{ $t('event.timeline.zoomMeeting.minutes') }}, {{ props.seconds }} {{ $t('event.timeline.zoomMeeting.seconds') }}.</template>
      </VueCountdown>
    </div>

    <div class="text-center p-5">
      <a
        :href="'/'+eventSlug+'/zoom-meeting/'+reaction.id+'/'+attendeeId"
        target="_blank"
        class="items-center justify-center px-5 py-3 border border-transparent text-base no-underline font-medium rounded-lg text-white bg-info-50 hover:bg-info-30"
      >
        {{ $t('event.timeline.zoomMeeting.button') }}
      </a>
    </div>

  </div>
</template>

<script>

import VueCountdown from '@chenfengyuan/vue-countdown'
import Mixin from './mixin'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  mixins: [Mixin],

  data () {
    return {
      started: false,
      time: 0
    }
  },

  components: {
    VueCountdown
  },

  props: {
    url: {
      type: String,
      default: ''
    },
    reaction: {
      type: Object
    }
  },

  computed: {
    ...mapState({
      eventSlug: state => state.routeParameters.event.slug,
      attendeeId: state => state.routeParameters.attendee.id
    })
  },

  created: function () {
    this.calculateTime()
  },

  methods: {
    startCount: function () {
      this.$refs.countdown.start()
    },

    stopCount: function () {
      this.$refs.countdown.abort()
    },

    calculateTime: function () {
      const date = moment(this.reaction.data.zoomMeeting.date)
      const duration = moment.duration(date.diff(moment()))
      const diffInMiliseconds = duration.asMilliseconds()
      this.time = diffInMiliseconds
      this.started = true
    }
  }
}
</script>
